import { DeleteAssignmentV3Document } from '@/store/v2';
import { FetchResult, useMutation } from '@apollo/client';

import { ASSIGNMENTS_QUERY_OPERATION_NAME } from './constants';
import { AssignmentsV3Result } from './types';

export const useDeleteAssignment = (): {
  deleteAssignment: (id: number) => Promise<FetchResult<{ deleteAssignmentV3: AssignmentsV3Result }>>;
  loading: boolean;
} => {
  const [deleteAssignment, { loading }] = useMutation<{ deleteAssignmentV3: AssignmentsV3Result }>(DeleteAssignmentV3Document);

  return {
    deleteAssignment: async (id: number) =>
      deleteAssignment({
        variables: { id },
        refetchQueries: [ASSIGNMENTS_QUERY_OPERATION_NAME],
      }),
    loading,
  };
};
